import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "container-full-1 bg-grey-50" }
const _hoisted_2 = { class: "s20 widget flex align-items-center px-1 py-5" }
const _hoisted_3 = { class: "s4_mobile h-100p px-2" }
const _hoisted_4 = { class: "mb-2" }
const _hoisted_5 = { class: "s3_mobile h-100p px-2" }
const _hoisted_6 = { class: "font-normal mb-5" }
const _hoisted_7 = { class: "s4_mobile h-100p px-3" }
const _hoisted_8 = {
  key: 0,
  class: "font-normal"
}
const _hoisted_9 = { class: "text-2xl" }
const _hoisted_10 = { class: "s7_mobile h-100p px-5" }
const _hoisted_11 = {
  class: "h-60 rounded-100 position-relative",
  style: {"width":"100%","background-color":"rgba(var(--color-black-rgb), 0.1)"}
}
const _hoisted_12 = {
  class: "h-100p flex align-items-center justify-content-left rounded-100 text-2xl px-5 bg-pop-green",
  style: {"width":"100%"}
}

import { ref } from 'vue';
    import { formatAmount, formatDateFrench } from '@/utils';
    import { useRoute } from 'vue-router';
    import FinancePrelevementsWallet from './@components/FinancePrelevementsWalletComponent.vue';
    import FinancePrelevementsForm from './@forms/FinancePrelevementsForm.vue';
    import FinancePrelevementsDecaissements from './@components/FinancePrelevementsDecaissementsComponent.vue';
    import ConfirmationModal from '@/components/ConfirmationModal.vue';
import axios from 'axios';
    
    
export default /*@__PURE__*/_defineComponent({
  __name: 'FinancePrelevementsDetailsView',
  setup(__props) {

    const route = useRoute();
    const startup_infos: any = route.meta.startup_infos;
    const collectivite: any = startup_infos.collectivite;
    const financePrelevementsWalletRef = ref<InstanceType<typeof FinancePrelevementsWallet> | null>(null);
    const financePrelevementsDecaissementsRef = ref<InstanceType<typeof FinancePrelevementsDecaissements> | null>(null);
    const confirmationModalRef = ref<InstanceType<typeof ConfirmationModal> | null>(null);
    const loadingSendInvitations = ref(false);
    const errorMessageSendInvitations = ref('');

    async function onPrelevementFormUpdated(onValidatePrelevementResponse?: { is_first_prelevement: boolean }) {
        if (financePrelevementsDecaissementsRef.value) {
            financePrelevementsDecaissementsRef.value.doGetDecaissementDetailsInfos();
        }
        if (financePrelevementsWalletRef.value) {
            financePrelevementsWalletRef.value.doGetWalletDetailsInfos();
        }

        if (onValidatePrelevementResponse?.is_first_prelevement == true) {
            const confirmation = await confirmationModalRef.value!.open("Prélèvements", "Le premier prélèvement a été validé avec succès. Voulez-vous envoyer les liens d'invitations aux membres de la collectivité pour qu'ils puissent accéder à leur espace personnel et valider leur souscription ?");
            if (confirmation) {
                    loadingSendInvitations.value = true;
                    try {
                    const response = await axios.post('/backoffice/collectivites/membres/send_invitations_unverified', {
                        collectivite_id: collectivite.id
                    });
                } catch(error: any) {
                    errorMessageSendInvitations.value = error.message;
                } finally {
                    loadingSendInvitations.value = false;
                }
            }
        }
    }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _cache[6] || (_cache[6] = _createStaticVNode("<div class=\"page-space-40\"></div><h4 class=\"s7 font-semibold px-3 pb-5\">Finance / Prélèvement <span class=\"text-sm text-grey-500\"></span></h4><div class=\"s13 flex-right gap-3 mt--2 mb-5 px-5\"><span class=\"btn shadow-200 white2\">Wallet</span><span class=\"btn shadow-200 white2\">Gérer les prélèvements</span><span class=\"btn shadow-200 light2 border-none\">Prélèvements / Décaissements</span></div>", 3)),
    _createElementVNode("div", _hoisted_2, [
      _cache[5] || (_cache[5] = _createElementVNode("div", { class: "s2_mobile h-100p px-7" }, [
        _createElementVNode("div", { class: "rounded-100 overflow-hidden item active" }, [
          _createElementVNode("img", {
            src: "/assets/logos/logo6.svg",
            width: "100%"
          })
        ])
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h4", _hoisted_4, _toDisplayString(_unref(collectivite).nom), 1),
        _cache[0] || (_cache[0] = _createElementVNode("h3", null, "C788PMKJ", -1))
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("h4", _hoisted_6, _toDisplayString(_unref(collectivite).users_count) + " membre(s)", 1),
        _cache[1] || (_cache[1] = _createElementVNode("span", { class: "tag-state notif stroke" }, "Actif", -1))
      ]),
      _createElementVNode("div", _hoisted_7, [
        (_unref(collectivite).created_at)
          ? (_openBlock(), _createElementBlock("h4", _hoisted_8, [
              _cache[2] || (_cache[2] = _createTextVNode(" Date de création ", -1)),
              _cache[3] || (_cache[3] = _createElementVNode("br", { class: "mb-2" }, null, -1)),
              _createElementVNode("b", _hoisted_9, _toDisplayString(_unref(formatDateFrench)(_unref(collectivite).created_at)), 1)
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _cache[4] || (_cache[4] = _createElementVNode("div", { class: "widget-floating py-0 text-xl flex-right" }, "Membres", -1)),
          _createElementVNode("div", _hoisted_12, _toDisplayString(_unref(collectivite).users_count) + " membre(s) ", 1)
        ])
      ])
    ]),
    _cache[7] || (_cache[7] = _createElementVNode("div", { class: "clear-both h-20" }, null, -1)),
    _createVNode(FinancePrelevementsWallet, {
      "startup-infos": _unref(startup_infos),
      ref_key: "financePrelevementsWalletRef",
      ref: financePrelevementsWalletRef
    }, null, 8, ["startup-infos"]),
    _cache[8] || (_cache[8] = _createElementVNode("div", { class: "clear-both h-5" }, null, -1)),
    _cache[9] || (_cache[9] = _createElementVNode("div", { class: "step vertical bg-grey-500 ml-auto mr-auto" }, null, -1)),
    _cache[10] || (_cache[10] = _createElementVNode("div", { class: "clear-both h-5" }, null, -1)),
    _createVNode(FinancePrelevementsForm, {
      "startup-infos": _unref(startup_infos),
      onUpdated: onPrelevementFormUpdated
    }, null, 8, ["startup-infos"]),
    _createVNode(FinancePrelevementsDecaissements, {
      "startup-infos": _unref(startup_infos),
      ref_key: "financePrelevementsDecaissementsRef",
      ref: financePrelevementsDecaissementsRef
    }, null, 8, ["startup-infos"]),
    _cache[11] || (_cache[11] = _createElementVNode("div", { class: "clear-both h-50" }, null, -1)),
    _createVNode(ConfirmationModal, {
      ref_key: "confirmationModalRef",
      ref: confirmationModalRef
    }, null, 512)
  ]))
}
}

})